import React from "react";
import {MonthToText} from "../../../../AdminPart/src/Constants";

function createDangerHTML(info) {
    return {__html : info}
}

function Blog(props) {

    //console.log('Blogprops',props);
    const content = props.posts.map(function(post,index) {
        const arrDate = post.NewsDate.split('-');
        return <div key={index} className="AboutNewsElement">
        <div className="AboutNewsElementDate">
            <div className="AboutNewsElementDateDate">{arrDate[2]}</div>
            <div className="AboutNewsElementDateMonth">{MonthToText(+arrDate[1],props.lang)}</div>
            <div className="AboutNewsElementDateYear">{arrDate[0]}</div>
            <div className="AboutNewsElementNewsTitle" dangerouslySetInnerHTML= {createDangerHTML(JSON.parse(post.Title)[props.lang])}/>
        </div>
        <div className="AboutNewsElementNews">

            <div className="AboutNewsElementNewsText" dangerouslySetInnerHTML= {createDangerHTML(JSON.parse(post.Text)[props.lang])}/>
        </div>
    </div>}

    );
    return (
        <div>
            {content}
        </div>
    );
}



export default Blog
